import Rout from './Component/Rout'
export default function App() {
  return (
    <div>
      <Rout/> 
    </div>
  )
}
